export default "__VITE_ASSET__DQ3o3A9Z__"